import { extends as _extends, asyncToGenerator as _asyncToGenerator, regeneratorRuntime as _regeneratorRuntime } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import { Form } from '../../Form/Form.js';
import { ModalForm } from '../../ModalForm/index.js';
import { noop } from '../../../utils/noop.js';
import { useConfirmAction } from '../../../hooks/useConfirmAction.js';
import { useContainerProps } from '../../../hooks/useContainerProps.js';
import { JsonApiRecordDecorator } from '../../../json-api/JsonApiRecordDecorator.js';
/** renders a form module intended for use inside a section */

var FormModule = function FormModule(props) {
  props = useContainerProps(props);
  var _props = props,
      children = _props.children,
      _props$confirmCancel = _props.confirmCancel,
      confirmCancel = _props$confirmCancel === void 0 ? {
    disabled: true
  } : _props$confirmCancel,
      _props$confirmSave = _props.confirmSave,
      confirmSave = _props$confirmSave === void 0 ? {
    disabled: true
  } : _props$confirmSave,
      _props$createMember = _props.createMember,
      createMember = _props$createMember === void 0 ? noop : _props$createMember,
      currentEntity = _props.currentEntity,
      isModal = _props.isModal,
      noPaddingButtons = _props.noPaddingButtons,
      onCancel = _props.onCancel,
      onError = _props.onError,
      onSuccess = _props.onSuccess,
      _props$saveAndAddButt = _props.saveAndAddButton,
      saveAndAddButton = _props$saveAndAddButt === void 0 ? false : _props$saveAndAddButt,
      _props$selectMember = _props.selectMember,
      selectMember = _props$selectMember === void 0 ? noop : _props$selectMember,
      title = _props.title,
      _props$updateMember = _props.updateMember,
      updateMember = _props$updateMember === void 0 ? noop : _props$updateMember;

  function performSaveAction(_x, _x2, _x3) {
    return _performSaveAction.apply(this, arguments);
  }

  function _performSaveAction() {
    _performSaveAction = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(type, data, addAnother) {
      var action, response;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              action = noop;
              _context.t0 = type;
              _context.next = _context.t0 === 'create' ? 4 : _context.t0 === 'update' ? 6 : 8;
              break;

            case 4:
              action = createMember;
              return _context.abrupt("break", 8);

            case 6:
              action = updateMember;
              return _context.abrupt("break", 8);

            case 8:
              _context.prev = 8;
              _context.next = 11;
              return action(Object.assign(new JsonApiRecordDecorator(), currentEntity, data), addAnother);

            case 11:
              response = _context.sent;

              if (response) {
                selectMember(null);
                if (onSuccess) onSuccess();
              }

              _context.next = 18;
              break;

            case 15:
              _context.prev = 15;
              _context.t1 = _context["catch"](8);
              if (onError) onError();

            case 18:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[8, 15]]);
    }));
    return _performSaveAction.apply(this, arguments);
  }

  function performCancelAction() {
    if (onCancel) {
      onCancel();
    } else {
      selectMember(null);
    }
  }

  var _useConfirmAction = useConfirmAction({
    action: performSaveAction,
    children: confirmSave.children,
    disabled: confirmSave.disabled,
    title: confirmSave.title
  }),
      saveAction = _useConfirmAction.action,
      saveConfirmationModal = _useConfirmAction.confirmationModal;

  var _useConfirmAction2 = useConfirmAction({
    action: performCancelAction,
    children: confirmCancel.children,
    disabled: confirmCancel.disabled,
    title: confirmCancel.title
  }),
      cancelAction = _useConfirmAction2.action,
      cancelConfirmationModal = _useConfirmAction2.confirmationModal;

  var createAction = function createAction(data, addAnother) {
    return saveAction('create', data, addAnother);
  };

  var updateAction = function updateAction(data) {
    return saveAction('update', data);
  };

  var FormComponent = isModal ? ModalForm : Form;
  return /*#__PURE__*/React.createElement(React.Fragment, null, currentEntity && /*#__PURE__*/React.createElement(FormComponent, _extends({}, props, {
    title: title,
    data: currentEntity,
    onCancel: cancelAction,
    addAction: createAction,
    updateAction: updateAction,
    saveAndAddButton: saveAndAddButton,
    buttonGroupClass: "modal-footer ".concat(noPaddingButtons ? 'no-padding' : '')
  }), children), saveConfirmationModal, cancelConfirmationModal);
};

FormModule.propTypes = {
  children: PropTypes.node,
  confirmCancel: PropTypes.shape({
    title: PropTypes.string,
    children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
    disabled: PropTypes.bool
  }),
  confirmSave: PropTypes.shape({
    title: PropTypes.string,
    children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
    disabled: PropTypes.bool
  }),
  createMember: PropTypes.func,
  currentEntity: PropTypes.object,
  isModal: PropTypes.bool,
  noPaddingButtons: PropTypes.bool,
  onCancel: PropTypes.func,
  onError: PropTypes.func,
  onSuccess: PropTypes.func,
  router: PropTypes.shape({
    goBack: PropTypes.func
  }),
  saveAndAddButton: PropTypes.bool,
  selectMember: PropTypes.func,
  updateMember: PropTypes.func,
  title: PropTypes.string
};
export { FormModule };